import {
    DataGridProps as DGProps,
    DataGrid as MuiDataGrid,
} from '@mui/x-data-grid';
import {
    DataGridPremiumProps as DGPremiumProps,
    DataGridPremium as MuiDataGridPremium,
} from '@mui/x-data-grid-premium';

export interface DataGridProps extends DGProps {
    error?: Error | null;
}

export function DataGrid({ error, ...props }: DataGridProps) {
    return (
        <MuiDataGrid
            paginationMode="server"
            sortingMode="server"
            pagination
            sx={{ border: 0 }}
            slotProps={{
                loadingOverlay: {
                    variant: 'linear-progress',
                    noRowsVariant: 'linear-progress',
                },
            }}
            {...props}
        />
    );
}

export function TreeDataGrid(props: DGPremiumProps) {
    return (
        <MuiDataGridPremium
            paginationMode="client"
            sortingMode="client"
            sx={{ border: 0 }}
            slotProps={{
                loadingOverlay: {
                    variant: 'linear-progress',
                    noRowsVariant: 'linear-progress',
                },
            }}
            {...props}
        />
    );
}
